import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
} from '../types';
import api from '../../services/api';

// Login user
export const login = (credentials) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_REQUEST });

    const response = await api.post('/auth/login', credentials);
    const { token, user } = response.data.data;

    dispatch({
      type: LOGIN_SUCCESS,
      payload: { token, user },
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Login failed';
    dispatch({
      type: LOGIN_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get user profile
export const getProfile = () => async (dispatch) => {
  try {
    dispatch({ type: GET_PROFILE_REQUEST });

    const response = await api.get('/auth/profile');
    const user = response.data.data;

    dispatch({
      type: GET_PROFILE_SUCCESS,
      payload: user,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get profile';
    dispatch({
      type: GET_PROFILE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Logout user
export const logout = () => (dispatch) => {
  dispatch({ type: LOGOUT });
};
